import { useMemo } from 'react';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { ADMIN_ROLE } from 'all-in-one-shared-api';

export const useCheckAdminLoggedIn = () => {
  const { keycloak, initialized } = useKeycloak();

  const isAdminLoggedIn = useMemo(() => {
    return (
      initialized &&
      keycloak.authenticated &&
      keycloak.tokenParsed?.resource_access?.['react-auth']?.roles?.some((role) =>
        Object.values(ADMIN_ROLE)
          .map((role) => role.toString())
          .includes(role),
      )
    );

    // when the roles are changed, the user need to log in again
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialized, keycloak.authenticated]);

  return isAdminLoggedIn;
};
